import { Chip } from '@mui/material';
import { styled, css } from '@mui/material/styles';
import { spacing } from '@mui/system';
import { switchProp } from 'styled-tools';
import { shouldNotForwardProps, withUtility } from '../../foundation/utils.js';

let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13;
const Tag = styled(Chip, {
  shouldForwardProp: shouldNotForwardProps
})(_t || (_t = _`
  ${0};

  height: ${0};

  border-radius: ${0};

  font-size: ${0};

  ${0};

  .MuiChip-icon {
    ${0};
    margin-right: ${0};
    margin-left: ${0};
  }
`), spacing, switchProp('size', {
  small: '28px',
  medium: '36px'
}), switchProp('size', {
  small: '14px',
  medium: '18px'
}), switchProp('size', {
  small: '12px',
  medium: '14px'
}), withUtility(({
  palette
}, {
  variant
}) => {
  switch (true) {
    case variant === 'neutral':
      return css(_t2 || (_t2 = _`
          background-color: ${0};
          color: ${0};
        `), palette('surfaceVariant'), palette('onSurfaceVariant'));
    case variant === 'positive':
      return css(_t3 || (_t3 = _`
          background-color: ${0};
          color: ${0};
        `), palette('successContainer'), palette('onSuccessContainer'));
    case variant === 'attention':
      return css(_t4 || (_t4 = _`
          background-color: ${0};
          color: ${0};
        `), palette('warningContainer'), palette('onWarningContainer'));
    case variant === 'negative':
      return css(_t5 || (_t5 = _`
          background-color: ${0};
          color: ${0};
        `), palette('errorContainer'), palette('onErrorContainer'));
    case variant === 'informative':
      return css(_t6 || (_t6 = _`
          background-color: ${0};
          color: ${0};
        `), palette('infoContainer'), palette('onInfoContainer'));
    default:
      return css(_t7 || (_t7 = _``));
  }
}), withUtility(({
  palette
}, {
  variant
}) => {
  switch (true) {
    case variant === 'neutral':
      return css(_t8 || (_t8 = _`
            color: ${0};
          `), palette('onSurfaceVariant'));
    case variant === 'positive':
      return css(_t9 || (_t9 = _`
            color: ${0};
          `), palette('onSuccessContainer'));
    case variant === 'attention':
      return css(_t10 || (_t10 = _`
            color: ${0};
          `), palette('onWarningContainer'));
    case variant === 'negative':
      return css(_t11 || (_t11 = _`
            color: ${0};
          `), palette('onErrorContainer'));
    case variant === 'informative':
      return css(_t12 || (_t12 = _`
            color: ${0};
          `), palette('onInfoContainer'));
    default:
      return css(_t13 || (_t13 = _``));
  }
}), switchProp('iconPosition', {
  left: '-6px',
  right: '5px',
  center: '-6px'
}), switchProp('iconPosition', {
  left: '5px',
  right: '-6px',
  center: '8px'
}));

export { Tag };
